// extracted by mini-css-extract-plugin
module.exports = {"content":"BannerJobTypeSearch_content__nQJSq","title":"BannerJobTypeSearch_title__ukC3i","subtitle":"BannerJobTypeSearch_subtitle__3FPd5","job":"BannerJobTypeSearch_job__o_R3o"};